import { api } from './api';

function urlBase64ToUint8Array(base64: string): Uint8Array {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const base64Safe = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64Safe);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) output[i] = raw.charCodeAt(i);
  return output;
}

/** Чи підтримує цей браузер/контекст PWA-сповіщення взагалі (для показу/приховування тумблера в "Більше"). */
export function pushSupported(): boolean {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

/** Чи ввімкнені сповіщення в ЦЬОМУ браузері прямо зараз (є активна підписка). */
export async function isPushEnabled(): Promise<boolean> {
  if (!pushSupported()) return false;
  try {
    const registration = await navigator.serviceWorker.ready;
    const sub = await registration.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}

/**
 * Вмикає PWA-сповіщення про нові розділи в ЦЬОМУ браузері: запитує дозвіл
 * ОС/браузера, підписується на push і надсилає підписку серверу (де вона
 * зберігається саме для поточного акаунта — src/routes/notifications.ts).
 * Кидає помилку з людяним текстом, якщо щось пішло не так (немає дозволу,
 * незахищений контекст тощо) — виклик має бути обгорнутий у try/catch.
 */
export async function enablePushNotifications(): Promise<void> {
  if (!pushSupported()) {
    throw new Error('Цей браузер не підтримує push-сповіщення');
  }
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    throw new Error('Дозвіл на сповіщення не надано');
  }

  const registration = await navigator.serviceWorker.ready;
  const { publicKey } = await api.vapidPublicKey();
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey) as BufferSource,
  });

  await api.subscribePush(subscription.toJSON());
}

/** Вимикає PWA-сповіщення в ЦЬОМУ браузері — типовий (за замовчуванням) стан. */
export async function disablePushNotifications(): Promise<void> {
  if (!pushSupported()) return;
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;
  const endpoint = subscription.endpoint;
  await subscription.unsubscribe();
  await api.unsubscribePush(endpoint).catch(() => {
    /* сервер міг вже й сам прибрати "мертву" підписку (src/lib/notify-updates.ts) — не критично */
  });
}
